var render = function render(){var _vm=this,_c=_vm._self._c;return (!!_vm.image)?_c('a',{staticClass:"img-container",attrs:{"href":_vm.link}},[_c('img',{class:{ rectangle: _vm.isRectangular, 'not-rectangle': !_vm.isRectangular, fullWidth: _vm.fullWidth },attrs:{"src":`${_vm.image}`,"alt":_vm.altMessage,"width":"100%","loading":"lazy"},on:{"load":_vm.checkAspectRatio,"error":_vm.handleImageError}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }